export const ActorName: Record<components['schemas']['ActorEnum'], string> = {
  sender: 'Sender',
  recipient: 'Recipient',
  system: 'System',
}

export const BillComparisonStatusName: Record<
  components['schemas']['BillComparisonStatusEnum'],
  string
> = {
  pending: 'Pending',
  in_progress: 'In progress',
  cancelled: 'Cancelled',
  completed: 'Completed',
  failed: 'Failed',
  disregarded: 'Disregarded',
}

export const BillStatusName: Record<
  components['schemas']['BillStatusEnum'],
  string
> = {
  prepare: 'Prepare',
  'not-prepare': 'Not prepare',
  pending: 'Pending',
}

export const CallStatusName: Record<
  components['schemas']['CallStatusEnum'],
  string
> = {
  busy: 'Busy',
  canceled: 'Canceled',
  completed: 'Completed',
  failed: 'Failed',
  'in-progress': 'In progress',
  'no-answer': 'No answer',
  queued: 'Queued',
  ringing: 'Ringing',
  'conference-start': 'Conference start',
  'conference-end': 'Conference end',
  'participant-join': 'Participant join',
  'participant-leave': 'Participant leave',
}

export const ContractStatusName: Record<
  components['schemas']['ContractStatusEnum'],
  string
> = {
  draft: 'Draft',
  sent: 'Sent',
  viewed: 'Viewed',
  'partially-signed': 'Partially signed',
  completed: 'Completed',
  declined: 'Declined',
  voided: 'Voided',
  expired: 'Expired',
}

export const ContractStatusIcon: Record<components['schemas']['ContractStatusEnum'], string> = {
  draft: 'pi pi-pencil',
  sent: 'pi pi-send',
  viewed: 'pi pi-eye',
  'partially-signed': 'pi pi-pen-to-square',
  completed: 'pi pi-check-circle',
  declined: 'pi pi-times-circle',
  voided: 'pi pi-ban',
  expired: 'pi pi-clock',
}

export const ContractStatusSeverity: Record<
  components['schemas']['ContractStatusEnum'],
  string
> = {
  draft: 'secondary',
  sent: 'info',
  viewed: 'info',
  'partially-signed': 'warn',
  completed: 'success',
  declined: 'danger',
  voided: 'contrast',
  expired: 'contrast',
}

export const ContractRecipientKindName: Record<
  components['schemas']['ContractRecipientKindEnum'],
  string
> = {
  signer: 'Needs to sign',
  cc: 'Receives a copy',
}

export const ContractRecipientStatusName: Record<
  components['schemas']['ContractRecipientStatusEnum'],
  string
> = {
  created: 'Not sent yet',
  sent: 'Sent',
  viewed: 'Viewed',
  completed: 'Signed',
  declined: 'Declined',
}

export const ContractRecipientStatusSeverity: Record<
  components['schemas']['ContractRecipientStatusEnum'],
  string
> = {
  created: 'secondary',
  sent: 'info',
  viewed: 'info',
  completed: 'success',
  declined: 'danger',
}

export const ContractSigningOrderName: Record<
  components['schemas']['ContractSigningOrderEnum'],
  string
> = {
  sequential: 'One after another',
  parallel: 'All at once',
}

export const CrewTypeName: Record<
  components['schemas']['CrewTypeEnum'],
  string
> = {
  subcontractor: 'Subcontractor',
  'field-worker': 'Field worker',
  'office-worker': 'Office worker',
}

export const CrewTypeSeverity: Record<
  components['schemas']['CrewTypeEnum'],
  string
> = {
  subcontractor: 'contrast',
  'field-worker': 'info',
  'office-worker': 'secondary',
}

export const DuplicatesName: Record<
  components['schemas']['DuplicatesEnum'],
  string
> = {
  stop: 'Stop',
  ignore: 'Ignore',
  add_to_campaign: 'Add to campaign',
}

export const FeeTypeName: Record<components['schemas']['FeeTypeEnum'], string> =
  {
    fixed: 'Fixed',
    percentage: 'Percentage',
  }

export const FieldTypeName: Record<
  components['schemas']['FieldTypeEnum'],
  string
> = {
  signature: 'Signature',
  initials: 'Initials',
  'text-single': 'Text',
  'text-multiple': 'Textarea',
  email: 'Email',
  'phone-number': 'Phone number',
  number: 'Number',
  currency: 'Currency',
  percentage: 'Percentage',
  checkbox: 'Checkbox',
  'radio-group': 'Radio group',
  dropdown: 'Drop down',
  'foreign-key': 'Foreign key',
  'date-signed': 'Signed date',
  'date-picker': 'Date picker',
  'signer-name': 'Signer name',
  attachment: 'Attachment',
}

export const GenericFieldName: Record<string, Record<string, string>> = {
  manager: {
    adjuster: 'Adjuster',
    customer: 'Customer',
  },
  crm: {
    lead: 'Contact',
  },
  scheduling: {
    crew: 'Crew',
  },
}

export const GenericFieldURL: Record<string, Record<string, string>> = {
  manager: {
    adjuster: '/manager/adjusters/',
    customer: '/manager/customers/',
  },
  crm: {
    lead: '/crm/leads/',
  },
  scheduling: {
    crew: '/setup/crews/',
  },
}

export const DirectionName: Record<
  components['schemas']['DirectionEnum'],
  string
> = {
  inbound: 'Inbound',
  outbound: 'Outbound',
}

export const EmailDirectionName: Record<
  components['schemas']['DirectionEnum'],
  string
> = {
  inbound: 'Inbound',
  outbound: 'Outbound',
}

export const EmailLoopStatusName: Record<
  components['schemas']['EmailLoopStatusEnum'],
  string
> = {
  active: 'Active',
  inactive: 'Inactive',
  paused: 'Paused',
  completed: 'Completed',
}

export const EmailLoopStatusSeverity: Record<
  components['schemas']['EmailLoopStatusEnum'],
  string
> = {
  active: 'primary',
  inactive: 'contrast',
  paused: 'warn',
  completed: 'info',
}

export const EmailStatusName: Record<
  components['schemas']['NotificationStatusEnum'],
  string
> = {
  bounce: 'Bounce',
  queued: 'Queued',
  sent: 'Sent',
  failed: 'Failed',
  delivered: 'Delivered',
  opened: 'Opened',
  open: 'Open',
  processed: 'Processed',
  dropped: 'Dropped',
  deferred: 'Deferred',
}

export const EmailStatusSeverity: Record<
  components['schemas']['NotificationStatusEnum'],
  string
> = {
  bounce: 'danger',
  queued: 'secondary',
  sent: 'info',
  failed: 'danger',
  delivered: 'success',
  opened: 'success',
  open: 'success',
  processed: 'success',
  dropped: 'danger',
  deferred: 'danger',
}

export const FlowHandlerName: Record<
  components['schemas']['FlowHandlerEnum'],
  string
> = {
  browser: 'Browser',
  'ring-1-number': 'Ring 1 number',
  'round-robin': 'Round robin',
  'multiple-numbers': 'Multiple numbers',
}

export const MessageStatusName: Record<
  components['schemas']['MessageStatusEnum'],
  string
> = {
  queued: 'Queued',
  sending: 'Sending',
  sent: 'Sent',
  failed: 'Failed',
  delivered: 'Delivered',
  undelivered: 'Undelivered',
  receiving: 'Receiving',
  received: 'Received',
  accepted: 'Accepted',
  scheduled: 'Scheduled',
  read: 'Read',
  partially_delivered: 'Partially delivered',
  canceled: 'Canceled',
}

export const ProjectCheckStatusName: Record<
  components['schemas']['CheckStatusEnum'],
  string
> = {
  amount_approved: 'Amount Approved',
  issued: 'Issued',
  sent: 'Sent to the mortgage for endorsement',
  mailed: 'In the mail to us',
  scheduled_for_pickup: 'Check scheduled for pickup',
}

export const ProjectStatusName: Record<
  components['schemas']['ProjectStatusEnum'],
  string
> = {
  cancelled: 'Cancelled',
  completed: 'Completed',
  'in-progress': 'In Progress',
  'legal-department': 'Legal Department',
  pending: 'Pending',
  'collection-done': 'Collection Done',
  'approval-finalized': 'Approval Finalized',
  'ready-to-close': 'Ready to Close',
}

export const ProjectStatusSeverity: Record<
  components['schemas']['ProjectStatusEnum'],
  string
> = {
  cancelled: 'contrast',
  completed: 'success',
  'in-progress': 'info',
  'legal-department': 'warn',
  pending: 'secondary',
  'collection-done': 'info',
  'approval-finalized': 'info',
  'ready-to-close': 'success',
}

export const ProjectTypeName: Record<
  components['schemas']['ProjectTypeEnum'],
  string
> = {
  insurance: 'Insurance',
  cash: 'Cash',
}

export const ProjectTypeSeverity: Record<
  components['schemas']['ProjectTypeEnum'],
  string
> = {
  insurance: 'success',
  cash: 'info',
}

export const PromptName: Record<
  components['schemas']['ParameterNameEnum'],
  string
> = {
  bill_comparison: 'Bill comparison',
  rewrite: 'Rewrite',
  email_compose: 'Email compose',
}

export const TemplateTypeName: Record<
  components['schemas']['TemplateTypeEnum'],
  string
> = {
  email: 'Email',
  sms: 'SMS',
}

export const TimeOffReasonName: Record<
  components['schemas']['ReasonEnum'],
  string
> = {
  ooo: 'OOO',
  holiday: 'Holiday',
}

export const StatusStageName: Record<
  components['schemas']['StageEnum'],
  string
> = {
  new: 'New',
  booked: 'Booked',
  estimate: 'Estimate',
  followup: 'Follow-up',
  objection: 'Objection',
  reload: 'Reload',
  lost: 'Lost',
  sold: 'Sold',
}

export const StatusStageOrder: components['schemas']['StageEnum'][] = [
  'new',
  'booked',
  'estimate',
  'followup',
  'objection',
  'reload',
  'lost',
  'sold',
]

export const SourceModeName: Record<components['schemas']['ModeEnum'], string> =
  {
    counted: 'Counted',
    not_counted: 'Not counted',
    office: 'Office',
    hidden: 'Hidden',
  }

export const TouchReasonName: Record<string, string> = {
  counted: 'Counted',
  outbound: 'Outgoing',
  not_tracking_number: 'Not a tracking number / group text',
  from_company: 'From a company number',
  hidden_source: 'Hidden source',
  blocked: 'Blocked number',
  ivr_only: 'Hung up in IVR',
  other_extension: 'Other extension',
  invalid_phone: 'Not a customer phone',
}

export const TouchReasonSeverity: Record<string, string> = {
  counted: 'success',
  ivr_only: 'warn',
  blocked: 'danger',
}

export const JobTypeName: Record<components['schemas']['JobTypeEnum'], string> =
  {
    fire_damage: 'Fire damage',
    smoke_damage: 'Smoke damage',
    water_damage: 'Water damage',
    mold_remediation: 'Mold remediation',
  }

export const EstimateStatusName: Record<
  components['schemas']['EstimateStatusEnum'],
  string
> = {
  new: 'New',
  sent: 'Sent',
  followup: 'Follow-up',
  '2nd_followup': 'Second follow-up',
  standby: 'Standby',
  need_to_sign: 'Need to sign',
  signed: 'Signed',
  rejected: 'Rejected',
}

export const EstimateStatusColor: Record<
  components['schemas']['EstimateStatusEnum'],
  string
> = {
  new: 'A4C2F4',
  sent: '9FC5E8',
  followup: 'FFD966',
  '2nd_followup': 'F6B26B',
  standby: 'D9D9D9',
  need_to_sign: 'B4A7D6',
  signed: '93C47D',
  rejected: 'EA9999',
}

export const TypeOfWorkName: Record<
  components['schemas']['TypeOfWorkEnum'],
  string
> = {
  reconstruction: 'Reconstruction',
  mitigation: 'Mitigation',
  service_agreement: 'Service Agreement',
  change_order: 'Change Order',
}
